<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <FoilCutterForm
        :station-id="stationId"
        :table-url="tableUrl"
        isBackSheet
        class=""
      ></FoilCutterForm>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import TheHeader from "@/components/layouts/TheHeader.vue";
import FoilCutterForm from "@/components/foilcutter/FoilCutterForm.vue";

const stationId = 18;
const tableUrl = `/Material/GetLastMaterialFoil/18/15`;
const viewName = "Foil Cutter 3 / BackSheet";

onMounted(() => {
  document.title = viewName;
});
</script>
